export const GET_ALL_FILE_TYPES = 'GET_ALL_FILE_TYPES'
export const GET_FILE_TYPES_FOR_CONTEXT = 'GET_FILE_TYPES_FOR_CONTEXT'
export const ADD_FILE_TYPE = 'ADD_FILE_TYPE'
export const DELETE_SINGLE_FILE_TYPE = 'DELETE_SINGLE_FILE_TYPE'
export const DELETE_MANY_FILE_TYPES = 'DELETE_MANY_FILE_TYPES'
export const UPDATE_FILE_TYPE = 'UPDATE_FILE_TYPE'
export const VIEW_SELECTED_FILE_TYPE = 'VIEW_SELECTED_FILE_TYPE'
